<div *ngIf=" !isHandset else mobileTemplate">
  <div class="unitPickerContainer">
    <div class="grid" *ngIf="showHeaders">
      <div class="column-header">
        Army
      </div>
      <div class="column-header">
        Corps
      </div>
      <div class="column-header">
        Regiment #
      </div>
      <div class="column-header">
        State
      </div>
      <div class="column-header">
        Branch
      </div>
      <div class="column-header">
        Companies <sup matTooltip="You can choose multiple companies">†</sup>
      </div>
      <div></div>
    </div>
    <div class="grid">
      <!-- ....Begin Unit Army Section.... -->
      <div>
        <select name="armyChosen" #armyDropdown class="badge" (keydown)="handleKeypressCommands($event)" autofocus (ngModelChange)="unitArmyChoice($event)" [(ngModel)]="unitArmyChosen">
          <option class="badge" [ngValue]="undefined">Any</option>
          
            <option class="badge" *ngFor="let a of unitArmies" [ngValue]="ua[a]">{{a}}</option>
          
        </select>
      </div>
      <!-- ....End Unit Army Section.... -->
      <!-- ....Begin Corps Section.... -->
      <div>
        <select name="corpsChosen" #corpsDropdown class="badge" (keydown)="handleKeypressCommands($event)" (ngModelChange)="corpsChoice($event)" [(ngModel)]="corpsChosen">
          <option [ngValue]="null" class="badge">Any</option>
          
            <option class="badge" *ngFor="let c of corps" [ngValue]="c">{{ ordinalSuffix(c) }}</option>
          
        </select>
      </div>
      <!-- ....End Corps Section.... -->
      <!-- ....Begin Regiment Section.... -->
      <div>
        <select class="badge" name="regimentChosen" (keydown)="handleKeypressCommands($event)" (ngModelChange)="regimentChoice($event)"
          [(ngModel)]="regimentChosen">
          <option class="badge" [ngValue]=null>Any</option>
          
            <option class="badge" *ngFor="let r of regiments" [ngValue]="r">{{ ordinalSuffix(r.regimentNo) }}</option>
          
        </select>
      </div>
      <!-- ....End Regiment Section.... -->
      <!-- ....Begin State Section.... -->
      <div>
        <select class="badge" (ngModelChange)="stateChoice($event)" (keydown)="handleKeypressCommands($event)"
          [(ngModel)]="stateChosen">
          <option class="badge" [ngValue]=null>Any</option>
          
            <option class="badge" *ngFor="let s of states" [ngValue]="s">{{ s.abbreviation }}</option>
          
        </select>
      </div>
      <!-- ....End State Section.... -->
      <!-- ....Begin Branch Section.... -->
      <div>
        <select class="badge" style="max-width: 100px;" (ngModelChange)="branchChoice($event)" (keydown)="handleKeypressCommands($event)"
          [(ngModel)]="branchChosen">
          <option class="badge" [ngValue]=null>Any</option>
          
            <option class="badge" *ngFor="let b of branches" [ngValue]="b">{{ b.branchName }}</option>
          
        </select>
      </div>
      <!-- ....End Branch Section.... -->
      <!-- ....Begin CoLetter Section.... -->
      <div>
        <!-- <div class="dropdown" dropdown container="body">
          <button id="companies-button" type="button" class="btn btn-sm badge" dropdownToggle aria-controls="companies-dropdown" (keydown)="handleCoLetterKeypress($event)">
            {{ (coLettersChosen.length > 0) ? coLettersChosen.join() : 'Any' }}
          </button>
          <ul id="companies-dropdown" role="menu" class="dropdown-menu" *dropdownMenu aria-labelledby="companies-button">
            <li role="menuitem">
              <a href="" class="dropdown-item badge" (click)="coLetterChoice(null)">Any</a>
            </li>
            <li role="menuitem" *ngFor="let l of coLetters">
              <a href="" class="dropdown-item badge" (click)="coLetterChoice(l)">
                {{ l }}
              </a>
            </li>
          </ul>
        </div> -->
        <div class="dropdown" role="button" data-bs-toggle="dropdown">
          <button class="btn btn-secondary btn-sm dropdown-toggle badge" (keydown)="handleCoLetterKeypress($event)">{{ (coLettersChosen.length > 0) ? coLettersChosen.join() : 'Any' }}</button>
          <div class="dropdown-menu">
            <a href="" class="dropdown-item badge" (click)="coLetterChoice(null)">Any</a>
            <a href="" class="dropdown-divider"></a>
            <a href="" *ngFor="let l of coLetters" class="dropdown-item badge" (click)="coLetterChoice(l)">{{ l }}</a>
          </div>
        </div>
      </div>
      <!-- ....End CoLetter Section.... -->

      <button *ngIf="!singleUnitMode" class="btn btn-secondary btn-sm" style="vertical-align: text-top;" type="button" matTooltip="Add and apply unit filter" id="addUFButton" (click)="done()">
        Add
        <i class="fal fa-sm fa-plus-hexagon ms-1"></i>
      </button>

    </div>
  </div>

</div>

<ng-template #mobileTemplate>

  <div class="unitPickerContainer">
    
    <div class="row">

      <div class="col-3">
        <div class="column-header">
          Army
        </div>
        <div>
          <select name="armyChosen" style="width: 100%;"#armyDropdown class="badge" (keydown)="handleKeypressCommands($event)" autofocus (ngModelChange)="unitArmyChoice($event)" [(ngModel)]="unitArmyChosen">
            <option class="badge" [ngValue]="0">Any</option>
            
              <option class="badge" *ngFor="let a of unitArmies" [ngValue]="ua[a]">{{a}}</option>
            
          </select>
        </div>

      </div>

      
      <div class="col-3">
        <div class="column-header">
          Corps
        </div>
        <div class="corps">
          <select name="corpsChosen" #corpsDropdown style="width: 100%;" class="badge mobile full-width-select" (keydown)="handleKeypressCommands($event)" (ngModelChange)="corpsChoice($event)" [(ngModel)]="corpsChosen">
            <option [ngValue]="null" class="badge">Any</option>
            
              <option class="badge" *ngFor="let c of corps" [ngValue]="c">{{ ordinalSuffix(c) }}</option>
            
          </select>
        </div>


      </div>

      <div class="col-1"></div>

      <div class="col-5">
        <div class="column-header">
          Regiment #
        </div>
        <div>
          <select class="badge"style="width: 100%;" name="regimentChosen" (keydown)="handleKeypressCommands($event)" (ngModelChange)="regimentChoice($event)"
            [(ngModel)]="regimentChosen">
            <option class="badge" [ngValue]=null>Any</option>
            
              <option class="badge" *ngFor="let r of regiments" [ngValue]="r">{{ ordinalSuffix(r.regimentNo) }}</option>
            
          </select>
        </div>


      </div>


    </div>
    <!-- SID: -->
    <div class="row">

      <div class="col-3">
        <div class="column-header">
          State
        </div>
        <div>
          <select class="badge" style="width: 100%;" (ngModelChange)="stateChoice($event)" (keydown)="handleKeypressCommands($event)"
            [(ngModel)]="stateChosen">
            <option class="badge" [ngValue]=null>Any</option>
            
              <option class="badge" *ngFor="let s of states" [ngValue]="s">{{ s.abbreviation }}</option>
            
          </select>
        </div>

      </div>

      <div class="col-3">
        <div class="column-header">
          Branch
        </div>
        <div>
          <select class="badge" style="width: 100%;" (ngModelChange)="branchChoice($event)" (keydown)="handleKeypressCommands($event)"
            [(ngModel)]="branchChosen">
            <option class="badge" [ngValue]=null>Any</option>
            
              <option class="badge" *ngFor="let b of branches" [ngValue]="b">{{ b.branchName }}</option>
            
          </select>
        </div>
      </div>

      <div class="col-1"></div>

      <div class="col-5">
        <div class="column-header">
          Companies <sup matTooltip="You can choose multiple companies">†</sup>
        </div>
        <div class="dropdown" style="width: 100%;"role="button" data-bs-toggle="dropdown">
          <button class="btn btn-secondary btn-sm dropdown-toggle badge" (keydown)="handleCoLetterKeypress($event)">{{ (coLettersChosen.length > 0) ? coLettersChosen.join() : 'Any' }}</button>
          <div class="dropdown-menu">
            <a href="" class="dropdown-item badge" (click)="coLetterChoice(null)">Any</a>
            <a href="" class="dropdown-divider"></a>
            <a href="" *ngFor="let l of coLetters" class="dropdown-item badge" (click)="coLetterChoice(l)">{{ l }}</a>
          </div>
        </div>
      </div>

    </div>

    <div class="row" style="justify-content: center;">
      <button *ngIf="!singleUnitMode" class="btn btn-secondary btn-sm" style="vertical-align: text-top;" type="button" matTooltip="Add and apply unit filter" id="addUFButton" (click)="done()">
        Add
        <i class="fal fa-sm fa-plus-hexagon ms-1"></i>
      </button>
    </div>
  </div>

</ng-template>
